import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldComponent } from '../field/field.component';
import { ServiceStock } from '../service-stock.service';

@Component({
  selector: 'app-cardsgroup',
  templateUrl: './cardsgroup.component.html',
  styleUrls: ['./cardsgroup.component.css']
})
export class CardsgroupComponent extends FieldComponent implements OnInit {
  @Input('fieldName') fieldName: string;
  @Input('iconClass') iconClass = "far fa-user-circle fa-2x";
  @Input('customClass') customClass = "blue-group";
  @Output('buttonClick') buttonClick = new EventEmitter<string>();
  constructor(services : ServiceStock) {
    super(services);
  }
  ngOnInit() {
    
  }

  onClick(event) {
     this.buttonClick.emit(event);
  }
  
}
